import { lessonApi, requestLessonApi } from '../api/api';
import { IS_DEMO } from '../config/env-config';

interface UploadInput {
  blob: Blob;
  startedAt: number;
  lessonInfo: {
    lessonId: string;
    roomId: string;
  };
  targetUserId: string;
}
interface IRecordingService {
  upload(input: UploadInput): Promise<void>;
}
class RecordingServiceApp implements IRecordingService {
  async upload(input: UploadInput): Promise<void> {
    const { blob, lessonInfo, startedAt, targetUserId } = input;
    const response = await requestLessonApi(() =>
      lessonApi.lessonControllerGetUploadUrlOfRecordedFile(
        lessonInfo.lessonId,
        lessonInfo.roomId,
        startedAt,
        blob.type,
        targetUserId
      )
    );
    if (!Array.isArray(response.data.data)) {
      console.error('Upload URL could not be retrieved.');
      return;
    }
    const url = response.data.data[0];
    try {
      await fetch(url, {
        method: 'PUT',
        body: blob,
        headers: { 'Content-type': blob.type }
      });
    } catch (error) {
      console.error(error);
    }
  }
}
class RecordingServiceDemo implements IRecordingService {
  async upload(input: UploadInput): Promise<void> {
    console.log('Demo mode: upload called', input);
    const { blob } = input;
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${input.startedAt}`;
    a.click();
  }
}
export const RecordingService: new () => IRecordingService = IS_DEMO ? RecordingServiceDemo : RecordingServiceApp;
